import 'Main/main';

document
  .querySelectorAll(
    '.lavendla-packages__packages__package__expand-package button'
  )
  .forEach((toggle) => {
    const HANDLE = 'mobile-show';
    const container = toggle.parentNode.parentNode;

    toggle.addEventListener('click', () => {
      if (toggle.classList.contains(HANDLE)) {
        toggle.classList.remove(HANDLE);
        container.classList.remove(HANDLE);
      } else {
        toggle.classList.add(HANDLE);
        container.classList.add(HANDLE);
      }
    });
  });
